import { AutoComplete, ISelectType, useFormContext } from "@4uhub/lib4uhub";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import MainApi from "../../../../../../../services/mainApi.service";

const translationPath = "page.4uBus.uBusAutomationRobot.";

const SOFTWARE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/Software/AutomationExecutions/";
const softwareList = new MainApi<ISelectType>(SOFTWARE_ROUTE);

export const SoftwareSelect = memo(() => {
  const { t } = useTranslation();

  const { setValue } = useFormContext();

  const valueChangeHandler = useCallback(() => {
    setValue("uBusAutomationExecution", null);
  }, [setValue]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        name="software"
        label={t(translationPath + "software") || "Software"}
        getOptionLabel={(option) => option.name}
        size="small"
        fullWidth
        clearIcon={false}
        request={softwareList.list}
        onValueChange={valueChangeHandler}
      />
    </Grid>
  );
});
